import { useTranslation } from 'react-i18next';
import Image from "next/image";
import { Icon } from "@iconify/react";

export function AvatarStack() {
    const { t } = useTranslation();

    return (
        <div className="flex min-w-0 items-center gap-4">
            <div className="relative flex w-fit -space-x-3 group">
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-white dark:border-[#0a0a0a] overflow-hidden bg-slate-200 shadow-sm transition-transform duration-300 group-hover:-translate-y-1 relative z-10">
                    <Image
                        src="/images/ellis.webp"
                        alt="Ellis Velandia"
                        width={44}
                        height={44}
                        className="w-full h-full object-cover"
                    />
                </div>
                <div className="w-10 h-10 md:w-11 md:h-11 rounded-full border-2 border-white dark:border-[#0a0a0a] overflow-hidden bg-slate-800 flex items-center justify-center text-white shadow-sm transition-transform duration-300 group-hover:translate-x-1 relative z-0">
                    <Icon icon="tabler:code" className="w-5 h-5" />
                </div>
            </div>
            <div className="flex min-w-0 flex-col justify-center">
                <p className="text-sm font-semibold text-slate-900 dark:text-slate-100 leading-tight">
                    {t('Contact.testimonial')}
                </p>
                <p className="mt-1 text-xs leading-5 text-slate-600 dark:text-slate-300">
                    {t('Contact.location')}
                </p>
            </div>
        </div>
    );
}
